<template>
  <div>
    <div style="w-100">
      <div class="d-flex" style="position: absolute; z-index: 2 !important">
        <Button
          :size="15"
          color="#fd7e14"
          colorText="#ffffff"
          tooltip="Filtrar contenido"
          icon="fas fa-filter"
          round
          :width="30"
          class="mt-2 mb-3 mr-2"
          @click.native="openModal('modal'), ActionSetZindexTablaModal(true)"
          traslate
        />
        <Button
          :size="15"
          color="#dc3545"
          colorText="#ffffff"
          tooltip="Limpiar Filtros"
          icon="fas fa-filter"
          round
          :width="30"
          class="mt-2 mb-3 mr-2"
          traslate
          @click.native="recargarTabla()"
        />
      </div>
    </div>

    <ui-modal ref="modal" title="Filtros para tabla" size="large" align-top @close="actionSetShowModalfilterTariffLines(false)">

      <div class="container">

        <!-- Fila 1 -->
        <div class="row w-100">

          <!-- Naviera -->
          <div class="col-4">
            <div style="color: grey; font-size: 15px">Naviera</div>
            <multiselect 
                placeholder="Seleccionar" 
                :options="dataListaNaviera" 
                :searchable="true" 
                v-model="filtroNavieraModel"
                :multiple="true"
                label="name"
                track-by="name"
                :limit="1"
                :limitText=" count => `+ ${count} registros` "
                selectLabel="Agregar"
                deselectLabel="Quitar"
                selectedLabel="Agregado"
                :close-on-select="false"
              >
                <template slot="beforeList">
                  <div class="d-flex align-items-center ml-2 selectAll">
                    <input id="checkAllNaviera" type="checkbox" @change="seleccionarTodosNavieras($event, dataListaNaviera)">
                    <label class="mt-2 ml-2" style="width:100%" for="checkAllNaviera">Seleccionar todo</label>
                  </div>
                </template>

            </multiselect>
          </div>

          <!-- Naviera Salida -->
          <div class="col-4">
            <div style="color: grey; font-size: 15px">Naviera Salida</div>
            <multiselect 
                placeholder="Seleccionar" 
                :options="navierasNoUCCList" 
                :searchable="true" 
                v-model="filtroNavieraSalidaModel"
                :multiple="true"
                label="name"
                track-by="name"
                :limit="1"
                :limitText=" count => `+ ${count} registros` "
                selectLabel="Agregar"
                deselectLabel="Quitar"
                selectedLabel="Agregado"
                :close-on-select="false"
              >
                <template slot="beforeList">
                  <div class="d-flex align-items-center ml-2 selectAll">
                    <input id="checkAllNavSalida" type="checkbox" @change="seleccionarTodosNavierasSalida($event, navierasNoUCCList)">
                    <label class="mt-2 ml-2" style="width:100%" for="checkAllNavSalida">Seleccionar todo</label>
                  </div>
                </template>

            </multiselect>
          </div>

          <!-- Commodity -->
          <div class="col-4">
            <div style="color: grey; font-size: 15px">Commodity</div>
            <multiselect 
                placeholder="Seleccionar" 
                :options="commodity" 
                :searchable="true" 
                v-model="filtroProductoModel"
                :multiple="true"
                label="name"
                track-by="name"
                :limit="1"
                :limitText=" count => `+ ${count} registros` "
                selectLabel="Agregar"
                deselectLabel="Quitar"
                selectedLabel="Agregado"
                :close-on-select="false"
              >
                <template slot="beforeList">
                  <div class="d-flex align-items-center ml-2 selectAll">
                    <input id="checkAll" type="checkbox" @change="seleccionarTodosCommodity($event, commodity)">
                    <label class="mt-2 ml-2" style="width:100%" for="checkAll">Seleccionar todo</label>
                  </div>
                </template>

            </multiselect>
          </div>
        </div>

        <!-- Fila 2 -->
        <div class="row w-100 mt-5">


          <!-- Destino -->
          <div class="col-4">
            <div style="color: grey; font-size: 15px">Destino</div>
            <multiselect 
                placeholder="Seleccionar" 
                :options="dataListaDestinos" 
                :searchable="true" 
                v-model="filtroDestinoModel"
                :multiple="true"
                label="name"
                track-by="name"
                :limit="1"
                :limitText=" count => `+ ${count} registros` "
                selectLabel="Agregar"
                deselectLabel="Quitar"
                selectedLabel="Agregado"
                :close-on-select="false"
                @select="getPODByDestination()"
              >
                <template slot="beforeList">
                  <div class="d-flex align-items-center ml-2 selectAll">
                    <input id="checkAllDestino" type="checkbox" @change="seleccionarTodosDestino($event, dataListaDestinos)">
                    <label class="mt-2 ml-2" style="width:100%" for="checkAllDestino">Seleccionar todo</label>
                  </div>
                </template>

            </multiselect>
          </div>

          <!-- POL -->
          <div class="col-4">
            <div style="color: grey; font-size: 15px">POL</div>
            <multiselect 
                placeholder="Seleccionar" 
                :options="dataListaPOL" 
                :searchable="true" 
                v-model="filtroPolModel"
                :multiple="true"
                label="name"
                track-by="name"
                :limit="1"
                :limitText=" count => `+ ${count} registros` "
                selectLabel="Agregar"
                deselectLabel="Quitar"
                selectedLabel="Agregado"
                :close-on-select="false"
                ref="select_pol"
              >
                <template slot="beforeList">
                  <div class="d-flex align-items-center ml-2 selectAll">
                    <input id="checkAllPol" type="checkbox" @change="seleccionarTodosPol($event, dataListaPOL)">
                    <label class="mt-2 ml-2" style="width:100%" for="checkAllPol">Seleccionar todo</label>
                  </div>
                </template>

            </multiselect>
          </div>

          <!-- POD -->
          <div class="col-4">
            <div style="color: grey; font-size: 15px">POD</div>
            <multiselect 
                placeholder="Seleccionar" 
                :options="filtroDestinoModel.length === 0 ? dataListaPOD : podListByDestination"
                :searchable="true" 
                v-model="filtroPodModel"
                :disabled="podListDisabled"
                :multiple="true"
                label="name"
                track-by="name"
                :limit="1"
                :limitText=" count => `+ ${count} registros` "
                selectLabel="Agregar"
                deselectLabel="Quitar"
                selectedLabel="Agregado"
                :close-on-select="false"
                ref="select_pod"
              >
                <template slot="beforeList">
                  <div class="d-flex align-items-center ml-2 selectAll">
                    <input id="checkAllPod" type="checkbox" @change="seleccionarTodosPod($event, filtroDestinoModel.length === 0 ? dataListaPOD : podListByDestination)">
                    <label class="mt-2 ml-2" style="width:100%" for="checkAllPod">Seleccionar todo</label>
                  </div>
                </template>

            </multiselect>
          </div>

        </div>

        <div class="row w-100 mt-5">
          <div class="col-4">
            <date-picker
              class="w-100"
              floating-label
              type="date"
              value-type="format"
              :keys="{ value: 'id', label: 'name' }"
              @close="handleOpenChange"
              placeholder="Desde"
              v-model="filtroDesdeModel"
            />
          </div>
          <div class="col-4">
            <date-picker
              class="w-100"
              floating-label
              type="date"
              value-type="format"
              :keys="{ value: 'id', label: 'name' }"
              @close="handleOpenChange"
              placeholder="Hasta"
              v-model="filtroHastaModel"
            />
          </div>
          <div class="col-4">
            <div class="w-100">
              <ui-switch @change="busquedaEspecificaChange()" v-model="busquedaEspecifica">Búsqueda Fecha Específica
              </ui-switch>
            </div>
          </div>
        </div>

        <!-- Fila 3 -->
        <div class="row w-100 mt-5">
          <div class="col-4">
            <date-picker
              class="w-100 mt-3"
              type="date"
              placeholder="Vigencia"
              @close="handleOpenChange"
              value-type="format"
              v-model="filtroVigenciaModel"
            />
          </div>
          <div class="col-4">
            <ui-select
              class="w-100"
              has-search
              ref="select_t_contenedor"
              label="Tipo contenedor"
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :keys="{ value: 'id', label: 'name' }"
              v-model="filtroTipoContenedorModel"
              :options="contenedores">
            </ui-select>
          </div>
          <div class="col-4">
            <ui-select
              class="w-100"
              has-search
              ref="select_t_contrato"
              label="Tipo contrato"
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :keys="{ label: 'name', value: 'id' }"
              @change="searchContracts()"
              v-model="filtroTipoContratoModel"
              :options="tipoContratos">
            </ui-select>
          </div>
        </div>

        <!-- Fila 4 -->
        <div class="row w-100 mt-5">
          <div class="col-4">
            <ui-select
              class="w-100"
              has-search
              ref="select_contrato"
              label="Contrato"
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :keys="{ label: 'name', value: 'id' }"
              v-model="filtroContratoModel"
              :options="contracts">
            </ui-select>
            <ui-select
              class="w-100 mt-4"
              has-search
              label="Trat. frío"
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :keys="{ label: 'name', value: 'id' }"
              v-model="filtroColdtreatmentModel"
              :options="filtroColdtreatmentOptions">
            </ui-select>
          </div>
          <div class="col-4">
            <ui-select
              class="w-100"
              has-search
              label="Get Out"
              placeholder="Seleccionar"
              searchPlaceholder="Buscar"
              :keys="{ label: 'name', value: 'id' }"
              v-model="filtroGetOut"
              :options="[
                {id: 1, name: 'Si'},
                {id: 0, name: 'No'}
                ]">
            </ui-select>
          </div>

          <div class="col-4">
            <ui-textbox
              type  = "number"
              class = "w-100"
              floating-label
              v-model="filtroId"
              label = "ID Tariff Line"
            />
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="d-flex justify-content-between mt-5">
        <button class="btn btn-default" @click="closeModal('modal')">
          Cerrar
        </button>
        <div style="float: right">
          <button
            class="btn btn-secondary"
            style="margin-right: 15px"
            @click="clear"
          >
            Limpiar
          </button>
          <button
            class="btn btn-danger"
            @click="filtrarLista"
            id="btnRefFiltroAcuerdoLineas"
          >
            Filtrar
          </button>
          <button 
            v-if="showModalfilterTariffLines" 
            class="btn btn-outline-primary ml-2" 
            @click="generareExport"
          >
            Generar reporte
          </button>
        </div>
      </div>
    </ui-modal>
  </div>
</template>

<script>
// Select UI

import Vue from 'vue';
import UiSelect from "keen-ui/src/UiSelect";
import UiModal from "keen-ui/src/UiModal";
import UiSwitch from "keen-ui/src/UiSwitch";
import { mapActions, mapState } from "vuex";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/locale/es";
import "vue2-datepicker/index.css";
import Button from "../../../common/Button";

import Multiselect from 'vue-multiselect';


import { getAcuerdosLineasFiltros, getAcuerdosLineas, getContratosPorNavieraYTipo, getReportTariffLine, getPODByDestination, getListasAcuerdosBase } from "@/constants/lineas";

Vue.component('multiselect', Multiselect);

export default {
  props: ["showBuscarReemplazar", "data", "version"],
  data() {
    return {
      filtroNavieraModel: [],
      filtroNavieraSalidaModel: [],
      filtroPolModel: [],
      filtroPodModel: [],
      filtroDestinoModel: [],
      filtroProductoModel: [],
      filtroDesdeModel: "",
      filtroHastaModel: "",
      filtroBusquedaEspecificaDesdeModel: "",
      filtroBusquedaEspecificaHastaModel: "",
      filtroVigenciaModel: "",
      filtroTipoContenedorModel: {},
      filtroTipoContratoModel: {},
      busquedaEspecifica: false,
      filtroContratoModel: "Sin Contrato",
      filtroColdtreatmentModel: "",
      filtroColdtreatmentOptions: [],
      filtroGetOut: "",
      filtroId : null ,
      dataFilter: this.dataDatatableTarifasAcuerdosLineasFiltrada,
      contracts: [],
      navierasNoUCCList: [],
      podListByDestination: [],
      podListDisabled: false,
      // options: ['list', 'of', 'options'],
      options: [
        {id : 1 , name : 'uno'},
        {id : 2 , name : 'dos'},
        {id : 3 , name : 'tres'},
        {id : 4 , name : 'cuatro'},
        {id : 5 , name : 'cinco'},
      ],
    };
  },
  components: {
    UiSelect,
    Button,
    UiModal,
    DatePicker,
    UiSwitch,
    Multiselect
  },
  computed: {
    ...mapState("lineas", [
      "dataDatatableTarifasAcuerdosLineasFiltrada",
      "dataListaPOD",
      "dataListaNaviera",
      "dataListaNavierasNoUCC",
      "dataListaPOL",
      "dataListaProducto",
      "dataListaDestinos",
      "dataDatatableTarifasAcuerdosLineasInicial",
      "showModalfilterTariffLines",
    ]),
    ...mapState(["contenedores", "tipoContratos", "commodity"])
  },
  methods: {
    ...mapActions("lineas", [
      "actionSetDataListarTarifasAcuerdosLineas",
      "actionLimpiarDataAcuerdosLineas",
      "actionFilterDataAcuerdosLineas",
      "actionSetFilterStateAcuerdosLineas",
      "actionSetInactiveDeleteTariffLineByFilter",
      "actionSetShowModalfilterTariffLines"
    ]),
    ...mapActions(["ActionSetShowAcuerdoLineas", "ActionSetZindexTablaModal"]),

    seleccionarTodosDestino(event, options){
      if (event.target.checked) {
        this.filtroDestinoModel = options;
      }else{
        this.filtroDestinoModel = '';
      }
    },
    
    seleccionarTodosNavieras(event, options){
      if (event.target.checked) {
        this.filtroNavieraModel = options;
      }else{
        this.filtroNavieraModel = '';
      }
    },

    seleccionarTodosNavierasSalida(event, options){
      if (event.target.checked) {
        this.filtroNavieraSalidaModel = options;
      }else{
        this.filtroNavieraSalidaModel = '';
      }
    },

    seleccionarTodosCommodity(event, options){
      if (event.target.checked) {
        this.filtroProductoModel = options;
      }else{
        this.filtroProductoModel = '';
      }
    },

    seleccionarTodosPol(event, options){
      if (event.target.checked) {
        this.filtroPolModel = options;
      }else{
        this.filtroPolModel = '';
      }
    },

    seleccionarTodosPod(event, options){
      if (event.target.checked) {
        this.filtroPodModel = options;
      }else{
        this.filtroPodModel = '';
      }
    },

    async getPODByDestination() {

      if (this.filtroDestinoModel.length > 0) {

        this.podListDisabled = true;

        this.filtroPodModel = [];

        this.podListByDestination = await getPODByDestination({ "destinations": this.filtroDestinoModel.map(p => +p.id) ?? [] });

        this.podListDisabled = false;

      }

    },
    clear() {
      this.filtroNavieraModel = [];

      this.filtroNavieraSalidaModel = [];

      this.filtroPolModel = [];

      this.filtroPodModel = [];

      this.filtroDestinoModel = [];

      this.filtroProductoModel = [];

      this.filtroTipoContenedorModel = "";

      this.filtroTipoContratoModel = "";

      this.filtroContratoModel = "Sin Contrato";
      this.filtroColdtreatmentModel = "";

      this.podListByDestination = [];

      this.filtroBusquedaEspecificaHastaModel = "";

      this.filtroBusquedaEspecificaDesdeModel = "";

      this.filtroGetOut = "";

      this.filtroDesdeModel = "";

      this.filtroHastaModel = "";

      this.filtroVigenciaModel = "";

      this.filtroId = "";

      this.actionLimpiarDataAcuerdosLineas();

      this.actionSetFilterStateAcuerdosLineas(null);
    },
    busquedaEspecificaChange() {

      if (this.busquedaEspecifica) {
        this.filtroBusquedaEspecificaHastaModel = this.filtroHastaModel;
        this.filtroBusquedaEspecificaDesdeModel = this.filtroDesdeModel;
      } else {
        this.filtroBusquedaEspecificaHastaModel = "";
        this.filtroBusquedaEspecificaDesdeModel = "";
      }
    },
    async recargarTabla() {

      this.clear();
      this.$vToastify.loader("Recargando Tabla...");

      const { data_table } = await getAcuerdosLineas();
      this.actionSetDataListarTarifasAcuerdosLineas(data_table);
      this.$vToastify.stopLoader();
      this.actionSetInactiveDeleteTariffLineByFilter(true);
    },
    async searchContracts() {

      const form = { type: +this.filtroTipoContratoModel.id };

      this.contracts = await getContratosPorNavieraYTipo(form);
    },
    estadoButton(text, estado = true) {
      let buttonRef = document.querySelector("#btnRefFiltroAcuerdoLineas");
      buttonRef.innerHTML = text;
      buttonRef.disabled = estado;
    },
    generateForm(){
      const coldtreatmentId =
        typeof this.filtroColdtreatmentModel === "object"
          ? (this.filtroColdtreatmentModel.id ?? "")
          : (this.filtroColdtreatmentModel ?? "");

      return {
        naviera_id: this.filtroNavieraModel.map(n => +n.id) ?? [],
        naviera_salida_id: this.filtroNavieraSalidaModel.map(n => n.id) ?? [],
        pol: this.filtroPolModel.map(p => +p.id) ?? [],
        pod: this.filtroPodModel.map(p => +p.id) ?? [],
        destination_id: this.filtroDestinoModel.map(d => +d.id) ?? [],
        products_category_id: this.filtroProductoModel.map(p => +p.id) ?? [],
        from_date: this.filtroDesdeModel === undefined ? "" : this.filtroDesdeModel,
        to_date: this.filtroHastaModel === undefined ? "" : this.filtroHastaModel,
        vigencia: this.filtroVigenciaModel ?? "",
        container_id: this.filtroTipoContenedorModel.id ?? "",
        tipo_contrato: this.filtroTipoContratoModel.id ?? "",
        get_out: this.filtroGetOut.id ?? null,
        from_date_specific: this.filtroBusquedaEspecificaDesdeModel ?? "",
        to_date_specific: this.filtroBusquedaEspecificaHastaModel ?? "",
        tariff_contract_id:
          this.filtroContratoModel === undefined ||
          this.filtroContratoModel === "Sin Contrato"
            ? ""
            : this.filtroContratoModel.id,
        coldtreatment_id: coldtreatmentId,
        version: this.version,
        id : this.filtroId ? this.filtroId : null
      };

    },
    async filtrarLista() {
      this.ActionSetShowAcuerdoLineas(true);

      const form = this.generateForm();

      this.actionSetFilterStateAcuerdosLineas(form);
      this.$vToastify.loader("Filtrando Acuerdo de Líneas...");
      this.estadoButton("Filtrando...");

      try {

        let { data_table } = await getAcuerdosLineasFiltros(form);
        this.actionSetDataListarTarifasAcuerdosLineas(data_table);
        this.$vToastify.stopLoader();
        this.estadoButton("Filtrar", false);
        this.closeModal("modal");
        this.actionSetInactiveDeleteTariffLineByFilter(false);
      } catch (error) {
        this.$vToastify.error(
          "Error al filtrar datos, recargue la página y vuelva a intentar",
          "Error"
        );
        this.$vToastify.stopLoader();
        this.estadoButton("Filtrar", false);
      }
    },
    async generareExport() {

      if( this.showModalfilterTariffLines ){

        if( !this.filtroDesdeModel && !this.filtroVigenciaModel) return this.$vToastify.warning(
          "Para generar reporte, se debe agregar fecha Desde o Vigencia",
          "Precaución"
        );

      }
      
      const form = this.generateForm();

      this.actionSetFilterStateAcuerdosLineas(form);

      this.$vToastify.loader("Generando Reporte...");

      try {
        
        await getReportTariffLine( form );

        this.$vToastify.stopLoader();
        
        return this.$vToastify.success("Se ha generado reporte, en unos momentos llegará a su correo.", "Éxito");

      } catch (error) {

        this.$vToastify.stopLoader();

        return this.$vToastify.error(
          "Hubo un error al generar reporte, recargue la página y vuelva a intentar.",
          "Error"
        );
        
      }
    },
    openModal(ref) {
      this.ActionSetZindexTablaModal(true);
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.$refs[ref].close();
      this.ActionSetZindexTablaModal(false);
    },
    handleOpenChange() {
      this.showTimePanel = false;
    },
    async loadFilterLists() {
      const { lista_coldtreatment } = await getListasAcuerdosBase();
      this.filtroColdtreatmentOptions = lista_coldtreatment || [];
    }
  },
  mounted() {
    this.loadFilterLists();
  },
  watch: {
    dataListaNavierasNoUCC: function(_new) {
      if (_new.length > 0) {
        this.navierasNoUCCList.push({ id: null, name: "SIN NAVIERA DE SALIDA" });
        _new.forEach(item => {
          this.navierasNoUCCList.push(item);
        });
      }
    },
    showModalfilterTariffLines : function ( _new ) {
      _new ? this.openModal('modal') : this.closeModal("modal") ;
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
  .mx-input {
    padding-left: 2px !important;
    border-radius: 0px !important;
    border: none !important;
    border-bottom: 1px solid #dcdcdc !important;
    box-shadow: none !important;
  }

  .selectAll > [type="checkbox"]{
    width: 18px; 
    height: 18px;
  }

  .selectAll :hover{
    cursor: pointer;
  }

  .multiselect__tags {
    border-radius: 0px !important;
    border: none !important;
    border-bottom: 1px solid #e8e8e8 !important;
    font-size: 16px !important;
    padding: 4px 40px 0 8px !important;
    min-height: 32px;
  }

  .multiselect, .multiselect__input, .multiselect__single {
    font-size: 14px;
}

</style>
